import axios from 'axios';

export const fetch = (url, credencial, params) => {
    const urlParams = new URLSearchParams();

    if (params) {
        for (let key in params) {
            const paramValue = params[key];

            if (Array.isArray(paramValue)) {
                paramValue.forEach(value => urlParams.append(key, value));
            } else {
                urlParams.append(key, paramValue);
            }
        }
    }

    return axios.get(url, {
        headers: {
            'credencial': credencial
        },
        params: urlParams
    }).then(response => {
        return response.data;
    }).catch(_handleErrorResponse);
};

export const create = (url, credencial, data) => {
    return axios.post(url, data, {
        headers: {
            'credencial': credencial
        }
    }).then(response => {
        return response.data;
    }).catch(_handleErrorResponse);
};

export const update = (url, credencial, data) => {
    return axios.put(url, data, {
        headers: {
            'credencial': credencial
        }
    }).then(response => {
        return response.data;
    }).catch(_handleErrorResponse);
};

export const remove = (url, credencial, data) => {
    return axios.delete(url, {
        headers: {
            'credencial': credencial
        },
        data
    }).then(response => {
        return response.data;
    }).catch(_handleErrorResponse);
};

const _handleErrorResponse = error => {
    if (error.response && error.response.data) {
        return Promise.reject(error.response.data);
    }

    return Promise.reject(error.message); // Mesmo efeito: 'throw error.message'
};